import React from 'react';
import type { RealestateAd, RealestateProjectAd } from '../../../types';

type RealestateLocationProps = {
    ad: RealestateAd | RealestateProjectAd;
    className?: string;
};

export function RealestateLocation(props: RealestateLocationProps) {
    const { ad, className } = props;

    if (!ad.location) {
        return null;
    }

    return (
        <div className={className}>
            <span className="text-s s-text-subtle">{ad.location}</span>
        </div>
    );
}
